import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '../firebase'

import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },

/* ====================================================================== */
  {
    path: '/calendar',
    name: 'Calendar',
    component: () => import(/* webpackChunkName: "calendar" */ '../views/Calendar.vue'),
    meta: {
      requiresAuth: true
    }
  },

/* ====================================================================== */
  {
    path: '/daily',
    name: 'Daily',
    component: () => import(/* webpackChunkName: "daily" */ '../views/Daily.vue'),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/daily/list',
    name: 'DailyList',
    component: () => import(/* webpackChunkName: "daily" */ '../views/DailyList.vue'),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/daily/edit/:date',
    name: 'DailyEdit',
    component: () => import(/* webpackChunkName: "daily" */ '../views/Daily.vue'),
    meta: {
      requiresAuth: true
    }
  },

/* ====================================================================== */
  {
    path: '/goals',
    name: 'Goals',
    component: () => import(/* webpackChunkName: "goals" */ '../views/Goal.vue'),
    children: [
      
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/goals/details/',
    name: 'GoalDetails',
    component: () => import(/* webpackChunkName: "goals" */ '../views/GoalsDetails.vue'),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/goals/achieved',
    name: 'GoalsAchieved',
    component: () => import(/* webpackChunkName: "goals" */ '../views/GoalsAchieved.vue'),
    children: [
      
    ],
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/goals/category/:category',
    name: 'GoalsCategory',
    component: () => import(/* webpackChunkName: "goals" */ '../views/GoalsCategory.vue'),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/goals/term/:term',
    name: 'GoalsTerm',
    component: () => import(/* webpackChunkName: "goals" */ '../views/GoalsTerm.vue'),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/goals/list/',
    name: 'GoalsList',
    component: () => import(/* webpackChunkName: "goals" */ '../views/GoalsList.vue'),
    meta: {
      requiresAuth: true
    }
  },

/* ====================================================================== */
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },

/* ====================================================================== */
  {
    path: '/targets',
    name: 'Targets',
    component: () => import(/* webpackChunkName: "targets" */ '../views/Target.vue'),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/targets/list/:category',
    name: 'TargetList',
    component: () => import(/* webpackChunkName: "targets" */ '../views/TargetsList.vue'),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/targets/date/:date',
    name: 'TargetDate',
    component: () => import(/* webpackChunkName: "targets" */ '../views/Target.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/targets/edit/:category/:startdate',
    name: 'TargetCategoryEdit',
    component: () => import(/* webpackChunkName: "targets" */ '../views/TargetCategory.vue'),
    meta: {
      requiresAuth: true
    }
  },
  
  {
    path: '/targets/edit/:id',
    name: 'TargetEdit',
    component: () => import(/* webpackChunkName: "targets" */ '../views/Target.vue'),
    meta: {
      requiresAuth: true
    }
  },

/* ====================================================================== */
  {
    path: '/wins',
    name: 'Win',
    component: () => import(/* webpackChunkName: "wins" */ '../views/Win.vue'),
    meta: {
      requiresAuth: true
    }
  },
  
  {
    path: '/wins/list',
    name: 'WinsList',
    component: () => import(/* webpackChunkName: "wins" */ '../views/WinsList.vue'),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/wins/date/:date',
    name: 'WinEdit',
    component: () => import(/* webpackChunkName: "wins" */ '../views/Win.vue'),
    meta: {
      requiresAuth: true
    }
  },


];

//================================================================
const router = createRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  history: createWebHistory(process.env.BASE_URL),
  routes
})

//================================================================
// navigation guard to check for logged in users
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)

  if (requiresAuth && !auth.currentUser) {
    next('/login')
  } else {
    next()
  }
})

export default router
